<template>
  <div>
    <el-aside>
      <SideMenu :items="items"></SideMenu>
    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main>
  </div>
</template>

<script>
import SideMenu from "@/components/common/SideMenu";

export default {
  components: {
    SideMenu,
  },
  data() {
    return {
      items: [
        { icon: "el-icon-truck", index: "test5-1", title: "政策速递" },
        { icon: "el-icon-s-order", index: "test5-2", title: "政策文库" },
      ],
    };
  },
};
</script>

<style>
</style>
